var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imageLoaded)?_c('div',{staticClass:"image-container"},[_c('img',{attrs:{"src":_vm.imageUrl,"alt":"Loaded Image"}}),_c('div',{staticClass:"text-overlay"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }